<div class="w-full h-12rem px-4 flex align-items-center justify-content-center " style="margin: -32px 0 0 0; background: url(../../../../assets/images/header_bg1.png) no-repeat left top #000086; background-size: cover;">
  <h1 class="w-full text-center font-bold text-2xl lg:text-6xl sm:text-4xl md:text-5xl " style="color: #fff;">College Rankings</h1>
</div>
<div class="w-full py-6" style="background-color: #fff;">
    <div class="container_width flex flex-column gap-4">
        <h2 class="text-center font-medium text-4xl" style="color: #212022;">United States</h2>
        <div class="w-full py-4 px-3 border-round-lg border-1 " style="border-color: #d0d0dd;">
            <div class="grid w-full">
                <div class="col-12 md:col-10">
                    <div class="flex flex-column w-full ">
                        <div class="flex flex-column gap-1 ">
                          <b class="text-left font-medium text-xl" style="color: #212022;" >Best Colleges Overall</b>
                          <p class="text-left font-normal text-base" style="color: #515055;" >Explore the best overall colleges</p>
                        </div>
                        <div class="w-full border-top-1 pt-3 mt-3 " style="border-color: #eee;">
                          <b class="text-left font-normal text-base" style="color: #2C4FD9;" >Best Colleges Overall</b>
                          <div class="w-full mt-1">
                              <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                                  <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 1</span>
                                  <b class="text-left font-normal text-base" style="color: #212022;" >Massachusetts Institute of Technology (MIT)</b>
                              </a>
                              <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                                <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 2</span>
                                <b class="text-left font-normal text-base" style="color: #212022;" >Harvard University</b>
                              </a>
                              <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                                <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 3</span>
                                <b class="text-left font-normal text-base" style="color: #212022;" >Stanford University</b>
                            </a>
                            <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                              <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 4</span>
                              <b class="text-left font-normal text-base" style="color: #212022;" >California Institute of Technology (Caltech)</b>
                            </a>
                            <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                              <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 5</span>
                              <b class="text-left font-normal text-base" style="color: #212022;" >University of Pennsylvania</b>
                          </a>
                          <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                            <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 6</span>
                            <b class="text-left font-normal text-base" style="color: #212022;" >University of California, Berkeley (UCB)</b>
                          </a>
                          <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                            <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 7</span>
                            <b class="text-left font-normal text-base" style="color: #212022;" >Cornell University</b>
                        </a>
                        <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                          <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 8</span>
                          <b class="text-left font-normal text-base" style="color: #212022;" >University of Chicago</b>
                        </a>
                        <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                          <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 9</span>
                          <b class="text-left font-normal text-base" style="color: #212022;" >Princeton University</b>
                      </a>
                      <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                        <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 10</span>
                        <b class="text-left font-normal text-base" style="color: #212022;" >Yale University</b>
                      </a>
                          </div>
                          <div class="w-full flex align-items-start mt-4">
                            <p-button (onClick)="showDialog()" label="View all colleges" styleClass="seeAll" />
                          </div>
                        </div>
                    </div>
                </div>
                <div class="hidden md:block md:col-2">
                    <div class="w-full">
                          <img src="../../../../assets/icons/school_building.svg" alt="" class="w-full">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="w-full py-6" style="background-color: #F5F5FE;">
  <div class="container_width flex flex-column gap-4">
      <h2 class="text-center font-medium text-4xl" style="color: #212022;">United Kingdom</h2>
      <div class="w-full py-4 px-3 border-round-lg border-1 bg-white " style="border-color: #d0d0dd;">
          <div class="grid w-full">
              <div class="col-12 md:col-10">
                  <div class="flex flex-column w-full ">
                      <div class="flex flex-column gap-1 ">
                        <b class="text-left font-medium text-xl" style="color: #212022;" >Best Colleges Overall</b>
                        <p class="text-left font-normal text-base" style="color: #515055;" >Explore the best overall colleges</p>
                      </div>
                      <div class="w-full border-top-1 pt-3 mt-3 " style="border-color: #eee;">
                        <b class="text-left font-normal text-base" style="color: #2C4FD9;" >Best Colleges Overall</b>
                        <div class="w-full mt-1">
                            <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                                <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 1</span>
                                <b class="text-left font-normal text-base" style="color: #212022;" >Imperial College London</b>
                            </a>
                            <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                              <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 2</span>
                              <b class="text-left font-normal text-base" style="color: #212022;" >University of Oxford</b>
                            </a>
                            <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                              <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 3</span>
                              <b class="text-left font-normal text-base" style="color: #212022;" >University of Cambridge</b>
                          </a>
                          <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                            <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 4</span>
                            <b class="text-left font-normal text-base" style="color: #212022;" >UCL</b>
                          </a>
                          <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                            <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 5</span>
                            <b class="text-left font-normal text-base" style="color: #212022;" >The University of Edinburgh</b>
                        </a>
                        <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                          <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 6</span>
                          <b class="text-left font-normal text-base" style="color: #212022;" >The University of Manchester</b>
                        </a>
                        <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                          <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 7</span>
                          <b class="text-left font-normal text-base" style="color: #212022;" >King's College London</b>
                      </a>
                      <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                        <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 8</span>
                        <b class="text-left font-normal text-base" style="color: #212022;" >The London School of Economics and Political Science (LSE)</b>
                      </a>
                      <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                        <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 9</span>
                        <b class="text-left font-normal text-base" style="color: #212022;" >University of Bristol</b>
                    </a>
                    <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                      <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 10</span>
                      <b class="text-left font-normal text-base" style="color: #212022;" >The University of Warwick</b>
                    </a>
                        </div>
                        <div class="w-full flex align-items-start mt-4">
                          <p-button (onClick)="showDialog()" label="View all colleges" styleClass="seeAll" />
                        </div>
                      </div>
                  </div>
              </div>
              <div class="hidden md:block md:col-2">
                  <div class="w-full">
                        <img src="../../../../assets/icons/uk-bc.svg" alt="" class="w-full">
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
<div class="w-full py-6" style="background-color: #F9FAEA;">
  <div class="container_width flex flex-column gap-4">
      <h2 class="text-center font-medium text-4xl" style="color: #212022;">India</h2>
      <div class="w-full py-4 px-3 border-round-lg border-1 bg-white " style="border-color: #d0d0dd;">
          <div class="grid w-full">
              <div class="col-12 md:col-10">
                  <div class="flex flex-column w-full ">
                      <div class="flex flex-column gap-1 ">
                        <b class="text-left font-medium text-xl" style="color: #212022;" >Best Colleges Overall</b>
                        <p class="text-left font-normal text-base" style="color: #515055;" >Explore the best overall colleges</p>
                      </div>
                      <div class="w-full border-top-1 pt-3 mt-3 " style="border-color: #eee;">
                        <b class="text-left font-normal text-base" style="color: #2C4FD9;" >Best Colleges Overall</b>
                        <div class="w-full mt-1">
                            <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                                <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 1</span>
                                <b class="text-left font-normal text-base" style="color: #212022;" >Imperial College London</b>
                            </a>
                            <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                              <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 2</span>
                              <b class="text-left font-normal text-base" style="color: #212022;" >University of Oxford</b>
                            </a>
                            <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                              <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 3</span>
                              <b class="text-left font-normal text-base" style="color: #212022;" >University of Cambridge</b>
                          </a>
                          <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                            <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 4</span>
                            <b class="text-left font-normal text-base" style="color: #212022;" >UCL</b>
                          </a>
                          <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                            <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 5</span>
                            <b class="text-left font-normal text-base" style="color: #212022;" >The University of Edinburgh</b>
                        </a>
                        <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                          <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 6</span>
                          <b class="text-left font-normal text-base" style="color: #212022;" >The University of Manchester</b>
                        </a>
                        <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                          <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 7</span>
                          <b class="text-left font-normal text-base" style="color: #212022;" >King's College London</b>
                      </a>
                      <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                        <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 8</span>
                        <b class="text-left font-normal text-base" style="color: #212022;" >The London School of Economics and Political Science (LSE)</b>
                      </a>
                      <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                        <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 9</span>
                        <b class="text-left font-normal text-base" style="color: #212022;" >University of Bristol</b>
                    </a>
                    <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
                      <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #6766B6; color: #fff; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 10</span>
                      <b class="text-left font-normal text-base" style="color: #212022;" >The University of Warwick</b>
                    </a>
                        </div>
                        <div class="w-full flex align-items-start mt-4">
                          <p-button (onClick)="showDialog()" label="View all colleges" styleClass="seeAll" />
                        </div>
                      </div>
                  </div>
              </div>
              <div class="hidden md:block md:col-2">
                  <div class="w-full">
                        <img src="../../../../assets/icons/india_building.svg" alt="" class="w-full">
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
<div class="w-full pt-6" style="background-color: #fff;">
  <div class="container_width flex flex-column gap-4 py-4 px-3 border-round-lg border-1 bg-white " style="border-color: #d0d0dd;">
      <h2 class="text-leftfont-medium text-4xl" style="color: #212022;">Best colleges by subject</h2>
      <div class="w-full">
          <div class="grid w-full">
              <div class="col-12 xl:col-3 md:col-6">
                  <div class="w-full p-3 border-round-lg border-1 flex flex-column gap-2 " style="border-color: #d0d0dd;">
                      <b class="text-left font-normal text-base" style="color: #2C4FD9;">Arts & Humanities</b>
                      <div class="flex flex-column gap-2">
                          <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                              <span class="text-left font-normal text-sm">Art & Design</span>
                              <i class="pi pi-angle-right"></i>
                          </a>
                          <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                            <span class="text-left font-normal text-sm">English Language & Literature</span>
                            <i class="pi pi-angle-right"></i>
                          </a>
                          <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                            <span class="text-left font-normal text-sm">History</span>
                            <i class="pi pi-angle-right"></i>
                          </a>
                          <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                            <span class="text-left font-normal text-sm">Performing Arts</span>
                            <i class="pi pi-angle-right"></i>
                          </a>
                          <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                            <span class="text-left font-normal text-sm">Philosophy</span>
                            <i class="pi pi-angle-right"></i>
                          </a>
                      </div>
                  </div>
              </div>
              <div class="col-12 xl:col-3 md:col-6">
                <div class="w-full p-3 border-round-lg border-1 flex flex-column gap-2 " style="border-color: #d0d0dd;">
                    <b class="text-left font-normal text-base" style="color: #2C4FD9;">Engineering & Technology</b>
                    <div class="flex flex-column gap-2">
                        <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                            <span class="text-left font-normal text-base">Computer Science</span>
                            <i class="pi pi-angle-right"></i>
                        </a>
                        <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                          <span class="text-left font-normal text-sm">Engineering - Electrical & Electronic</span>
                          <i class="pi pi-angle-right"></i>
                        </a>
                        <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                          <span class="text-left font-normal text-sm">Engineering - Mechanical, Aeronautical & Manufacturing</span>
                          <i class="pi pi-angle-right"></i>
                        </a>
                        <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                          <span class="text-left font-normal text-sm">Data Science</span>
                          <i class="pi pi-angle-right"></i>
                        </a>
                        <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                          <span class="text-left font-normal text-sm">Biological Sciences</span>
                          <i class="pi pi-angle-right"></i>
                        </a>
                        <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                          <span class="text-left font-normal text-sm">Medicine</span>
                          <i class="pi pi-angle-right"></i>
                        </a>
                        <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                          <span class="text-left font-normal text-sm">Psychology</span>
                          <i class="pi pi-angle-right"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-12 xl:col-3 md:col-6">
              <div class="w-full p-3 border-round-lg border-1 flex flex-column gap-2 " style="border-color: #d0d0dd;">
                  <b class="text-left font-normal text-base" style="color: #2C4FD9;">Psychology</b>
                  <div class="flex flex-column gap-2">
                      <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                          <span class="text-left font-normal text-sm">Environmental Sciences</span>
                          <i class="pi pi-angle-right"></i>
                      </a>
                      <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                        <span class="text-left font-normal text-sm">Mathematics</span>
                        <i class="pi pi-angle-right"></i>
                      </a>
                      <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                        <span class="text-left font-normal text-sm">Physics & Astronomy</span>
                        <i class="pi pi-angle-right"></i>
                      </a>
                  </div>
              </div>
          </div>
          <div class="col-12 xl:col-3 md:col-6">
            <div class="w-full p-3 border-round-lg border-1 flex flex-column gap-2 " style="border-color: #d0d0dd;">
                <b class="text-left font-normal text-base" style="color: #2C4FD9;">Social Sciences & Management</b>
                <div class="flex flex-column gap-2">
                    <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                        <span class="text-left font-normal text-sm">Accounting & Finance</span>
                        <i class="pi pi-angle-right"></i>
                    </a>
                    <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                      <span class="text-left font-normal text-sm">Business & Management Studies</span>
                      <i class="pi pi-angle-right"></i>
                    </a>
                    <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                      <span class="text-left font-normal text-sm">Law</span>
                      <i class="pi pi-angle-right"></i>
                    </a>
                    <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                      <span class="text-left font-normal text-sm">Social Policy & Administration</span>
                      <i class="pi pi-angle-right"></i>
                    </a>
                    <a class="flex align-items-center justify-content-between gap-2 border-1 ahLink" style="border-color: #e0e0ee; padding: 10px 10px 10px 16px; border-radius: 8px;">
                      <span class="text-left font-normal text-sm">Sports-Related Subjects</span>
                      <i class="pi pi-angle-right"></i>
                    </a>
                </div>
            </div>
        </div>
          </div>
      </div>
  </div>
</div>

<div class="container_width py-6">
  <p-accordion [activeIndex]="" styleClass="accord" class="w-full">
    <p-accordionTab header="Liberal Arts Colleges" iconPos="end" headerStyleClass="accord_inn">
      <div class="flex px-2 flex-column">
        <ul class="uni_list">
          <li>
            <a><span>Rank - 1</span> <b class="text-left font-normal text-base" style="color: #212022;">Williams College</b></a>
          </li>
          <li>
            <a><span>Rank - 2</span> <b class="text-left font-normal text-base" style="color: #212022;">Amherst College</b></a>
          </li>
          <li>
            <a><span>Rank - 3</span> <b class="text-left font-normal text-base" style="color: #212022;">Swarthmore College</b></a>
          </li>
          <li>
            <a><span>Rank - 4</span> <b class="text-left font-normal text-base" style="color: #212022;">United States Naval Academy</b></a>
          </li>
          <li>
            <a><span>Rank - 5</span> <b class="text-left font-normal text-base" style="color: #212022;">Bowdoin College</b></a>
          </li>
          <li>
            <a><span>Rank - 6</span> <b class="text-left font-normal text-base" style="color: #212022;">Pomona College</b></a>
          </li>
          <li>
            <a><span>Rank - 7</span> <b class="text-left font-normal text-base" style="color: #212022;">Wellesley College</b></a>
          </li>
          <li>
            <a><span>Rank - 8</span> <b class="text-left font-normal text-base" style="color: #212022;">Carleton College</b></a>
          </li>
          <li>
            <a><span>Rank - 9</span> <b class="text-left font-normal text-base" style="color: #212022;">Claremont McKenna College</b></a>
          </li>
          <li>
            <a><span>Rank - 10</span> <b class="text-left font-normal text-base" style="color: #212022;">United States Air Force Academy</b></a>
          </li>
        </ul>
        <div class="seemore"><a>View all colleges</a></div>
      </div>
    </p-accordionTab>
    <p-accordionTab header="Hardest to get into" iconPos="end" headerStyleClass="accord_inn1">
      <div class="flex px-2 flex-column">
      <ul class="uni_list">
        <li>
          <a><span class="yellow">Rank - 1</span> <b class="text-left font-normal text-base" style="color: #212022;">Minerva University</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 2</span> <b class="text-left font-normal text-base" style="color: #212022;">California Institute of Technology</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 3</span> <b class="text-left font-normal text-base" style="color: #212022;">Harvard University</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 4</span> <b class="text-left font-normal text-base" style="color: #212022;">Stanford University</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 5</span> <b class="text-left font-normal text-base" style="color: #212022;">Columbia University</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 6</span> <b class="text-left font-normal text-base" style="color: #212022;">Massachusetts Institute of Technology</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 7</span> <b class="text-left font-normal text-base" style="color: #212022;">Yale University</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 8</span> <b class="text-left font-normal text-base" style="color: #212022;">Brown University</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 9</span> <b class="text-left font-normal text-base" style="color: #212022;">University of Chicago</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 10</span> <b class="text-left font-normal text-base" style="color: #212022;">Princeton University</b></a>
        </li>
      </ul>
      <div class="seemore"><a>View all colleges</a></div>
    </div>
    </p-accordionTab>
    <p-accordionTab header="New age colleges in India" iconPos="end" headerStyleClass="accord_inn2">
      <div class="flex px-2 flex-column">
      <ul class="uni_list">
        <li>
          <a><span class="yellow">Rank - 1</span> <b class="text-left font-normal text-base" style="color: #212022;">Minerva University</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 2</span> <b class="text-left font-normal text-base" style="color: #212022;">California Institute of Technology</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 3</span> <b class="text-left font-normal text-base" style="color: #212022;">Harvard University</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 4</span> <b class="text-left font-normal text-base" style="color: #212022;">Stanford University</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 5</span> <b class="text-left font-normal text-base" style="color: #212022;">Columbia University</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 6</span> <b class="text-left font-normal text-base" style="color: #212022;">Massachusetts Institute of Technology</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 7</span> <b class="text-left font-normal text-base" style="color: #212022;">Yale University</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 8</span> <b class="text-left font-normal text-base" style="color: #212022;">Brown University</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 9</span> <b class="text-left font-normal text-base" style="color: #212022;">University of Chicago</b></a>
        </li>
        <li>
          <a><span class="yellow">Rank - 10</span> <b class="text-left font-normal text-base" style="color: #212022;">Princeton University</b></a>
        </li>
      </ul>
      <div class="seemore"><a>View all colleges</a></div>
    </div>
    </p-accordionTab>
</p-accordion>
</div>

<p-dialog
    header="College Ranking Wise"
    [modal]="true"
    [(visible)]="visible"
    [style]="{ width: '50rem' }"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
    <div class="flex flex-column">
      <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
        <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 1</span>
        <b class="text-left font-normal text-base" style="color: #212022;" >Massachusetts Institute of Technology (MIT)</b>
    </a>
    <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
      <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 2</span>
      <b class="text-left font-normal text-base" style="color: #212022;" >Harvard University</b>
    </a>
    <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
      <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 3</span>
      <b class="text-left font-normal text-base" style="color: #212022;" >Stanford University</b>
  </a>
  <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
    <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 4</span>
    <b class="text-left font-normal text-base" style="color: #212022;" >California Institute of Technology (Caltech)</b>
  </a>
  <a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
    <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 5</span>
    <b class="text-left font-normal text-base" style="color: #212022;" >University of Pennsylvania</b>
</a>
<a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
  <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 6</span>
  <b class="text-left font-normal text-base" style="color: #212022;" >University of California, Berkeley (UCB)</b>
</a>
<a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
  <span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 7</span>
  <b class="text-left font-normal text-base" style="color: #212022;" >Cornell University</b>
</a>
<a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
<span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 8</span>
<b class="text-left font-normal text-base" style="color: #212022;" >University of Chicago</b>
</a>
<a class="flex align-items-center gap-3 py-3 border-bottom-1" style="border-color: #e0e0ee;">
<span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 9</span>
<b class="text-left font-normal text-base" style="color: #212022;" >Princeton University</b>
</a>
<a class="flex align-items-center gap-3 pt-3">
<span class="font-normal text-base w-auto flex-shrink-0 " style="background-color: #E1E37E; color: #212022; border-radius: 10px 0 10px 10px; padding: 6px 12px;">Rank - 10</span>
<b class="text-left font-normal text-base" style="color: #212022;" >Yale University</b>
</a>
    </div>
</p-dialog>
